import { useTranslation } from 'react-i18next'

import { FormInput } from '@cash-web/shared-feature-form'
import { isValidEmail, isValidPhoneNumber } from '@cash-web/shared-util-validation'

import { Alias } from './BlockerAlias'

export const EmailInput = ({
  handleSetAliasType,
  loadingOverride,
}: {
  handleSetAliasType: (type: Alias['type'], prefilledEntry: string) => void
  loadingOverride: boolean | undefined
}) => {
  const { t } = useTranslation()
  const emailAddressErrorMessage = t('Enter a valid email address.', { context: 'Input Error.' })

  return (
    <FormInput
      placeholder={t('Your email address', { context: 'Input Placeholder.' })}
      name="email"
      autoFocus
      inputMode="email"
      autoCapitalize="off"
      autoComplete="email"
      spellCheck="false"
      autoCorrect="off"
      onPaste={(e: React.ClipboardEvent) => {
        const clipboardText = e.clipboardData.getData('text').trim()
        if (isValidPhoneNumber(clipboardText)) {
          e.preventDefault()
          handleSetAliasType('phone', clipboardText)
        }
      }}
      rules={{
        required: {
          message: emailAddressErrorMessage,
          value: true,
        },
        validate: (value: string) => {
          return isValidEmail(value) || emailAddressErrorMessage
        },
      }}
      readOnly={loadingOverride} // explicitly readOnly because disabled inputs have invalid valids on submit
    />
  )
}
